import { Flex, Spin, Typography } from 'antd'
import React, { useEffect, useState } from 'react'

import { InviteeService } from '@services/InviteeService'

import type { Invitee } from '../../../types'

import { InviteeTable } from './components/InviteeTable'

export const InvitesDashboardPage = () => {
    const [invitees, setInvitees] = useState<Invitee[]>()
    const [isLoading, setIsLoading] = useState(false)

    const list = async () => {
        setIsLoading(true)
        try {
            const results = await InviteeService.list()
            setInvitees(results)
        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        list()
    }, [])

    if (isLoading || !invitees) {
        return <Spin />
    }

    return (
        <>
            <Flex justify="space-between" align="center">
                <Typography.Title>Invites</Typography.Title>
            </Flex>
            <InviteeTable invitees={invitees} refetch={list} />
        </>
    )
}
